(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.onKeydown = this.onKeydown.bind(this);
      this.onRefresh = this.onRefresh.bind(this);
      this.lastFocus = null;
      this.closeTimer = null;
    }

    // Resolved on use. onRefresh() replaces this element's entire innerHTML on
    // every cart change, and a test variant can replace the header around it,
    // so neither the panel nor the overlay can be held in a property.
    get panel() { return this.querySelector('[data-cart-drawer]'); }
    get overlay() { return this.querySelector('[data-cart-drawer-overlay]'); }

    connectedCallback() {
      document.addEventListener('keydown', this.onKeydown);
      document.addEventListener('cart:refresh', this.onRefresh);

      // Close controls are delegated on this element, so the refresh below can
      // rewrite the drawer's markup without anything needing to re-bind. Bound
      // once: the listener stays put across a disconnect/reconnect.
      if (this._bound) return;
      this._bound = true;
      ThemeBind.delegate(this, 'click', '[data-cart-drawer-close]', () => this.close());
      ThemeBind.delegate(this, 'click', '[data-cart-drawer-overlay]', () => this.close());

      // Openers live outside the drawer (the header bag icon, add-to-cart
      // confirmations). They were bound per element at connect time, which meant
      // an opener rendered into a swapped-in header was never wired at all.
      // One delegated listener on document covers every opener, whenever it
      // arrives. The static flag keeps it to one registration per page even if
      // more than one <cart-drawer> is ever defined.
      if (!CartDrawer._openersBound) {
        CartDrawer._openersBound = true;
        ThemeBind.on('click', '[data-cart-drawer-open]', function (e) {
          const drawer = document.querySelector('cart-drawer');
          if (!drawer) return;
          e.preventDefault();
          drawer.open(this);
        });
      }
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      document.removeEventListener('cart:refresh', this.onRefresh);
    }

    // The innerHTML swap in onRefresh() replaces Rebuy's <div data-rebuy-id>
    // placeholders with fresh EMPTY ones. Rebuy populated the originals on page
    // load and has no way to know the DOM changed, so without this the cart
    // recommendations widget silently disappears after any cart update and only
    // comes back on a full page refresh.
    reinitRebuy() {
      if (!window.Rebuy) return;
      try {
        if (typeof window.Rebuy.init === 'function') {
          window.Rebuy.init();
        } else if (typeof window.Rebuy.reload === 'function') {
          window.Rebuy.reload();
        }
      } catch (e) {
        // Never let a Rebuy failure break the cart drawer.
      }
    }

    get isOpen() {
      return this.panel && this.panel.dataset.active !== undefined;
    }

    open(trigger) {
      const panel = this.panel;
      if (!panel) return;
      this.lastFocus = trigger || document.activeElement;
      window.clearTimeout(this.closeTimer);
      panel.hidden = false;
      requestAnimationFrame(() => {
        // Re-resolved: a refresh can replace the panel between frames.
        const current = this.panel;
        if (current) current.dataset.active = '';
        const overlay = this.overlay;
        if (overlay) overlay.dataset.active = '';
      });
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        const current = this.panel;
        if (current) current.focus();
      });
      document.dispatchEvent(new CustomEvent('cart-drawer:open'));
    }

    close() {
      const panel = this.panel;
      if (!panel) return;
      delete panel.dataset.active;
      const overlay = this.overlay;
      if (overlay) delete overlay.dataset.active;
      document.documentElement.style.overflow = '';
      this.closeTimer = window.setTimeout(() => {
        const current = this.panel;
        if (current) current.hidden = true;
      }, 300);
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
        try { this.lastFocus.focus(); } catch (e) {}
      }
      document.dispatchEvent(new CustomEvent('cart-drawer:close'));
    }

    onKeydown(e) {
      if (e.key === 'Escape' && this.isOpen) this.close();
    }

    // The market is decided by the URL prefix (/en-ie, /en-fr, …) - cookies don't
    // override it. A section render on a bare path therefore comes back in the
    // default GB market, which would repaint every `| money` in this drawer in
    // pounds. routes.root_url is Liquid-rendered for the CURRENT market, so
    // re-prefixing a pathname that has lost it is a no-op everywhere else.
    sectionsUrl() {
      const root = ((window.routes && window.routes.root_url) || '/').replace(/\/+$/, '') || '/';
      const path = window.location.pathname;
      if (root !== '/' && path !== root && path.indexOf(root + '/') !== 0) {
        return root + path + '?sections=header';
      }
      return path + '?sections=header';
    }

    // Pull fresh server-rendered markup for the header section (which contains both
    // the drawer and the bag-icon count) and swap it in. Triggered by `cart:refresh`;
    // pass `{ detail: { open: true } }` to also slide the drawer open afterwards.
    async onRefresh(e) {
      const shouldOpen = !!(e && e.detail && e.detail.open);
      // Open or shut is read when the new markup arrives, not before the fetch:
      // a shopper who closed the drawer while a refresh was loading had it pop
      // back open (Jack, 5 Oct 2026 - "rapidly opening and closing").
      let openNow = this.isOpen;

      try {
        const res = await fetch(this.sectionsUrl());
        if (res.ok) {
          const data = await res.json();
          const markup = data.header;
          if (markup) {
            const doc = new DOMParser().parseFromString(markup, 'text/html');

            const freshDrawer = doc.querySelector('cart-drawer');
            // No re-bind of our own controls afterwards: they are delegated on
            // this element and carry across the innerHTML swap. Rebuy is the
            // exception - it owns the DOM inside its placeholders and has to be
            // told they were replaced.
            if (freshDrawer) {
              openNow = this.isOpen;
              // The fresh markup is always the closed drawer. Swapped in as it
              // came, an open drawer snapped shut and slid open again on every
              // refresh; given the drawer's current state first, it just
              // updates in place, scrolled where it was.
              if (openNow) {
                const p = freshDrawer.querySelector('[data-cart-drawer]');
                const o = freshDrawer.querySelector('[data-cart-drawer-overlay]');
                if (p) { p.hidden = false; p.setAttribute('data-active', ''); }
                if (o) o.setAttribute('data-active', '');
              }
              const scrolls = Array.from(this.querySelectorAll('*')).filter((el) => el.scrollTop > 0).map((el) => el.scrollTop);
              this.innerHTML = freshDrawer.innerHTML;
              if (openNow && scrolls.length) {
                const first = Array.from(this.querySelectorAll('*')).find((el) => el.scrollHeight > el.clientHeight + 1 && getComputedStyle(el).overflowY !== 'visible');
                if (first) first.scrollTop = scrolls[0];
              }
              // keyboard focus was inside the old markup: keep it in the drawer
              if (openNow && this.panel) { try { this.panel.focus({ preventScroll: true }); } catch (e2) {} }
              this.reinitRebuy();
            }

            const freshBubble = doc.querySelector('#cart-icon-bubble');
            const liveBubble = document.querySelector('#cart-icon-bubble');
            if (freshBubble && liveBubble) liveBubble.innerHTML = freshBubble.innerHTML;
          }
        }
      } catch (err) {
        // Network/parse failure - fall through and still open with whatever's there.
      }

      // already open: updated in place above, nothing to slide in
      if (shouldOpen && !openNow) this.open(this.lastFocus);
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }
  } catch(e) { console.error(e); }
})();

})();
